module.exports = __webpack_public_path__ + "Euro_2020_Website_Banners_1_v2-a143f7e48fda8b05847a9699273b0c37.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Euro_2020_Website_Banners_1_v2.png
// module id = 1369
// module chunks = 1